<div class="header">
  <div class="copy">
    <h5 class="title">{{ title() }}</h5>
    @if (description()) {
      <p class="description">{{ description() }}</p>
    }
  </div>
  <div class="switch">
    @if (busy()) {
      <ct-lib-spinner [size]="20"></ct-lib-spinner>
    } @else {
      <input
        type="checkbox"
        class="ct-switch"
        [id]="switchId"
        [checked]="checked()"
        [disabled]="disabled()"
        [attr.aria-label]="switchAriaLabel() || title()"
        (change)="onToggle($any($event.target).checked)"
        (click)="$event.stopPropagation()"
      />
      <label [attr.for]="switchId" (click)="$event.stopPropagation()"></label>
    }
  </div>
</div>

<ng-content select="[lead]"></ng-content>

<div class="body" [@mirror]="checked() ? 'open' : 'closed'">
  <ng-content></ng-content>
</div>
